import withResolution from 'src/hoc/withResolution';
import SkuCategoryImage from './SkuCategoryImage';

export default withResolution(SkuCategoryImage);
